import MockAdapter from 'axios-mock-adapter'
import request from '../api/request'

import user from './user'
import role from './role'
import item from './item'

request.interceptors.request.use(function (req) {
  const method = req.method.toUpperCase()
  const query = Object.entries(req.params || {}).map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
  console.log(
    `%c[Mock] %c${method} %c${req.url}${query ? `?${query}` : ''}`,
    'font-weight: bold; color: green',
    'font-weight: bold',
    'font-weight: normal; text-decoration: underline'
  )
  if (method === 'POST' || method === 'PUT') {
    console.log(
      '%c[Mock] %cREQUEST BODY',
      'font-weight: bold; color: green',
      req.data
    )
  }
  return req
})

request.interceptors.response.use(function (res) {
  console.log(
    `%c[Mock] %cRESPONSE BODY`,
    'font-weight: bold; color: green',
    'font-weight: bold',
    res
  )
  return res
})

const getList = resource => ({
  ...resource.list,
  list: [...resource.list.list.map(item => ({ ...item }))]
})

const getOne = (list, params) => Object.assign({}, list.find(t => {
  if (!t) {
    return false
  }
  for (const [key, value] of Object.entries(params)) {
    // eslint-disable-line eqeqeq
    if (t[key] != value) {
      return false
    }
  }
  return true
}) || {})

const success = data => ({ retcode: 0, message: 'Success', data })
const failed = data => ({ retcode: 1, message: 'Failed', data })

const server = new MockAdapter(request)

server.onGet('/api/user/list').reply(200, success(getList(user)))
server.onGet('/api/user/details').reply(c => [200, success(getOne(user.list.list, c.params))])

server.onGet('/api/role/list').reply(200, success(getList(role)))
server.onGet('/api/role/details').reply(c => [200, success(getOne(role.list.list, c.params))])

server.onGet('/api/item/list').reply(200, success(getList(item)))
server.onGet('/api/item/details').reply(c => [200, success(getOne(item.list.list, c.params))])

server.onAny().reply(200, c => {
  console.log(`Unhandled url: ${c.url}`)
  return success()
})



// WEBPACK FOOTER //
// ./examples/mock/index.js